module.exports = __webpack_public_path__ + "img/25.bcf26088.jpg";